/**
 * @desc 公共方法和变量
 * @version version=1.0.0 2019-11-04
 * @author yd_yuliping
 */

import Vue from "vue";

/**
 * @desc 表格的列宽度
 * @version version=1.0.0 2019-11-04
 * @author yd_yuliping
 * @return {object} 列宽度
 */
Vue.prototype.tableEventWth = {
  /**复选框 */
  checkBox: 45,
  /**年度 */
  year: 100,
  /**期次 */
  times: 100,
  /**赛事类型 */
  type: 100,
  /**足球项目类型 */
  footballType: 300,
  /**赛事名称 */
  name: 280,
  /**经费 */
  funds: 150,
  /**经费 */
  provinceFunds: 150,
  /**经费 */
  countryFunds: 150,
  /**单位 */
  orgName: 200,
  /**项目 */
  disciplineList: 150,
  /**比赛日期 */
  gameDate: 180,
  /**地点 */
  cityName: 200,
  /**操作 */
  opt: 220,
  /**提交状态 */
  approveStatus: 80,
  /**人员数量 */
  personNum: 100
};

/**
 * @desc 数字转化成中文-金额
 * @version version=1.0.0 2019-11-04
 * @author yd_yuliping
 * @param {number} num 传入数值
 * @return {string} 数字的中文翻译
 */
Vue.prototype.numberToChinese = num => {
  /**检测传入是否为纯数字 */
  if (!/(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/g.test(num)) {
    return "";
  }
  num *= 100;
  // 处理111.11 * 100 不准确的问题
  num = parseFloat(num.toFixed(10));
  num += "";
  /**传入是否为空 */
  if (!num || num == "") {
    return "";
  }
  /**检测长度，超过千亿不显示 */
  // if (num && num.split(".")[0].length > 10) {
  //   return "";
  // }
  let _unit = ["仟", "佰", "拾", "", "仟", "佰", "拾", "", "仟", "佰", "拾", "", "角", "分"];
  let _toDx = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  let _result = "";
  for (let i = 0; i < num.length; i++) {
    if (i === 2) {
      _result = "圆" + _result;
    } else if (i === 6) {
      _result = "万" + _result;
    } else if (i === 10) {
      /**处理万元的问题 */
      if (_result.charAt(0) === "万") {
        _result = _result.substr(1);
      }
      _result = "亿" + _result;
    }
    /**从相反方向开始查询, 如 1234, i == 0,取4 */
    if (num.charAt(num.length - i - 1) === "0") {
      if (i != 0 && i != 1) {
        if (
          _result.charAt(0) != "零" &&
          _result.charAt(0) != "圆" &&
          _result.charAt(0) != "万" &&
          _result.charAt(0) != "亿"
        ) {
          _result = "零" + _result;
        }
      }
      continue;
    }
    _result = _toDx[num.charAt(num.length - i - 1)] + _unit[_unit.length - i - 1] + _result;
  }
  _result += _result.charAt(_result.length - 1) === "圆" ? "整" : "";
  return _result;
};

/**
 * @desc 对象赋值,将前面的对象值赋给后面的对象
 * @version version=1.0.0 2019-11-07
 * @author yd_yuliping
 * @param {object} baseObject 基础对象
 * @param {object} mergeObject 赋值的对象
 * @return {object} 已经赋值完的对象
 */
Vue.prototype.mergeObject = (baseObject, mergeObject) => {
  for (let i in mergeObject) {
    if (typeof baseObject[i] === "object") {
      mergeObject[i] = JSON.parse(JSON.stringify(baseObject[i]));
    } else {
      mergeObject[i] = baseObject[i] ? baseObject[i] : mergeObject[i];
    }
  }
  return mergeObject;
};

/**
 * @desc 添加分割符
 * @version version=1.0.0 2019-11-14
 * @author yd_yuliping
 * @param {string, number} data 传入数据
 * @param {string} separator 分隔符, 默认 ','
 * @param {number} num 没多少位分隔, 默认 3
 * @returns {string} 分隔后的结果
 */
Vue.prototype.addSeparator = (data, separator, num) => {
  data += "";
  let _separator = separator ? separator : ",";
  let _num = Number(num) ? Number(num) : 3;
  let s = "\\B(?=(?:\\d{" + _num + "})+\\b)";
  let reg = new RegExp(s, "g");
  let _data = data.replace(reg, _separator);
  return _data;
};
/**
 * @desc 处理成万元
 * @version version=1.0.0 2021-11-19
 * @author yd_yuliping
 * @param {string, number} data 传入数据
 * @returns {string} 处理后的结果
 */
Vue.prototype.numForTenThousand = data => {
  let _data = parseFloat((data / 10000).toFixed(10));
  return _data;
};
